import type { SelectedExtras } from "../types/resume";

export interface ExtraRoute {
	key: keyof SelectedExtras;
	path: string;
}

export const extrasRoutes: readonly ExtraRoute[] = [
	{ key: "accomplishments", path: "/resume/accomplishments" },
	{ key: "affiliations", path: "/resume/affiliations" },
	{ key: "websites", path: "/resume/personal-links" },
	{ key: "additionalInformation", path: "/resume/additional-information" },
	{ key: "certifications", path: "/resume/certifications" },
	{ key: "languages", path: "/resume/languages" },
	{ key: "reference", path: "/resume/reference-summary" },
	{ key: "profile", path: "/resume/personal-profile" },
	{ key: "customExtra", path: "/resume/custom-extra/" },
] as const;
